module.exports = new __parcel__URL__("company1.697f7fb3.png").toString();